<script setup>
import { computed, ref } from 'vue'
import axios from 'axios'
import Dialog from 'primevue/dialog'
import Swal from 'sweetalert2'

const props = defineProps({
  url: { type: String, default: null },
  selectedMonthlyActualReports: {
    type: Array,
    default: () => {
      return []
    }
  }
})

const emits = defineEmits(['post-succeed'])

// UI管理フラグ
const isLoading = ref(false)
const displayDialog = ref(false)

const errorMessage = ref('')
const result = ref([])

const isSubmitActive = computed(() => {
  if (isLoading.value) return false
  if (props.selectedMonthlyActualReports.length < 1) return false

  return true
})

async function submit() {
  const url = props.url
  const data = {
    monthly_actual_report_ids: props.selectedMonthlyActualReports.map(
      (report) => report.id
    )
  }
  const headers = { 'content-type': 'application/json' }
  isLoading.value = true
  axios.defaults.headers.common['X-CSRF-Token'] = document
    .querySelector('meta[name="csrf-token"]')
    .getAttribute('content')

  try {
    const res = await axios.post(url, data, { headers })
    isLoading.value = false
    result.value = res.data
    console.log(result.value) // 結果表示してないので一応ログだけ出してます
    emits('post-succeed')

    displayDialog.value = false
    await Swal.fire({
      icon: 'success',
      title: '実行完了',
      text: '数分以内に通知メールが送信されます',
      confirmButtonText: 'OK',
      confirmButtonColor: '#40BF6C',
      reverseButtons: true,
      allowOutsideClick: false
    })
    location.reload()
  } catch (error) {
    console.error('リクエストでエラーが発生しました:', error)
    errorMessage.value = error.response.data.errors.join(' ')
    isLoading.value = false
  }
}
</script>
<template>
  <div>
    <button
      :disabled="!isSubmitActive"
      class="group mr-3 flex items-center justify-center rounded-md border border-gray-500 bg-white py-2 pl-3 pr-4 text-sm font-medium text-gray-800 shadow-sm hover:border-transparent hover:bg-gray-500 hover:text-white sm:w-auto"
      :class="{ 'cursor-not-allowed opacity-50': !isSubmitActive }"
      @click="displayDialog = true"
    >
      <div class="flex items-center text-xs">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="h-5 w-5 pr-1 text-gray-500 group-hover:text-white"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75"
          />
        </svg>
        クリエイター・エージェントに通知
      </div>
    </button>
    <Dialog
      v-model:visible="displayDialog"
      header="作業明細の通知"
      :modal="true"
    >
      <vue-element-loading :active="isLoading" />
      <div>
        <div
          v-if="errorMessage"
          id="errors"
          class="mb-2 mt-2 rounded-md bg-red-50 p-4"
        >
          <div class="mt-2 text-sm text-red-700">エラー:{{ errorMessage }}</div>
        </div>
        <div class="mb-2">以下の作業明細書・注文書の通知を行います</div>
        <div class="mb-2">
          <p v-for="report in selectedMonthlyActualReports" :key="report.id">
            {{ report.name }}
          </p>
        </div>
      </div>
      <template #footer>
        <button
          :disabled="!isSubmitActive"
          class="ml-6 rounded-md border border-transparent bg-yellow-500 px-8 py-1.5 font-medium text-white shadow-sm hover:bg-yellow-600 focus:outline-none focus:ring-2 focus:ring-yellow-300 focus:ring-offset-2"
          :class="{ 'cursor-not-allowed opacity-50': !isSubmitActive }"
          @click="submit"
        >
          実行
        </button>
      </template>
    </Dialog>
  </div>
</template>
